import React from 'react';
import {
	Card,
	CardHeader,
	CardMedia,
	CardContent,
	CardActions,
	Button,
	Checkbox,
	IconButton,
} from "@material-ui/core";
import { Download, Pencil, Play, Trash } from "react-bootstrap-icons";
import { Base64Converter } from "../../../shared/utils/Base64Converter";

const MidiaLabsCardSingle = ({ midia, hasEditPermission, selected, onSelectChange, onEdit, onDelete }) => {
	const hasLink = midia.link && midia.link.trim() !== '';
	const hasFile = midia.arquivo_url && midia.arquivo_url.trim() !== '';

	const handleAccessClick = () => {
		if (hasLink) {
			window.open(midia.link, '_blank');
		}
	};

	const handleDownloadClick = () => {
		if (hasFile) {
			window.location.href = `${ process.env.REACT_APP_LABS_API }download_midia_labs.php?midia_id=${ midia.id }&type=arquivo`;
		}
	};

	return (
		<Card
			className={ `midia-labs-card${ selected ? ' midia-labs-card--selected' : '' }` }
		>
			{ hasEditPermission && (
				<CardHeader
					className="midia-labs-card__header"
					avatar={
						onSelectChange ? (
							<Checkbox
								checked={ !!selected }
								onChange={ (event) => onSelectChange(event.target.checked) }
								color="primary"
								size="small"
								inputProps={ { 'aria-label': 'Selecionar mídia' } }
							/>
						) : null
					}
					action={
						<div className="midia-labs-card__actions">
							<IconButton
								className="midia-labs-card__edit"
								onClick={ onEdit }
								title="Editar"
								id="midia-labs-card-edit-btn"
							>
								<Pencil size='18'/>
							</IconButton>
							<IconButton
								className="midia-labs-card__delete"
								onClick={ onDelete }
								title="Excluir"
								id="midia-labs-card-delete-btn"
							>
								<Trash size='20'/>
							</IconButton>
						</div>
					}
				/>
			) }

			<div className="midia-labs-card__image-wrapper">
				<CardMedia
					component="img"
					className="midia-labs-card__image"
					image={ midia.thumbnail_url || '/placeholder-image.jpg' }
					alt={ Base64Converter.decode(midia.nome) }
				/>
			</div>

			<CardContent className="midia-labs-card__content">
				<h5 className="midia-labs-card__title">{ Base64Converter.decode(midia.nome) }</h5>
			</CardContent>

			<CardActions className="midia-labs-card__buttons">
				<Button
					variant="contained"
					size="small"
					disableElevation
					className="midia-labs-card__download-btn"
					onClick={ handleDownloadClick }
					disabled={ !hasFile }
					startIcon={ <Download size='14'/> }
					id="midia-labs-card-download-btn"
				>
					Baixar
				</Button>

				<Button
					variant="contained"
					size="small"
					disableElevation
					className="midia-labs-card__access-btn"
					onClick={ handleAccessClick }
					disabled={ !hasLink }
					startIcon={ <Play size='14'/> }
					id="midia-labs-card-access-btn"
				>
					Acessar
				</Button>
			</CardActions>
		</Card>
	);
};

export default MidiaLabsCardSingle;
